// extracted by mini-css-extract-plugin
module.exports = {"bubbleContainer":"ChatBubble_bubbleContainer__2q46v","narvarUser":"ChatBubble_narvarUser__EIw8n","chatBubble":"ChatBubble_chatBubble__ekGs1"};